"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcLoadingBlock_module_scss_1 = __importDefault(require("./AcLoadingBlock.module.scss"));
exports.AcLoadingBlock = function () {
    return (react_1.default.createElement("div", { className: "d-flex align-items-center " + AcLoadingBlock_module_scss_1.default.loadingblock, style: { minHeight: '400px' } },
        react_1.default.createElement("div", { style: { height: '64px' }, className: "rounded shadow p-4 d-flex m-auto bg-white" },
            react_1.default.createElement("i", { className: "fas fa-2x fa-spin fa-spinner text-cloudLink" }))));
};
exports.AcLoadingBlock.displayName = 'AcLoadingBlock';
//# sourceMappingURL=AcLoadingBlock.js.map